module.exports = __webpack_public_path__ + "img/settings-1.c6f3469e.png";